import { useContext, useLayoutEffect, useRef } from 'react';

import { createInsightsMiddleware } from 'instantsearch.js/cjs/middlewares';
import md5 from 'md5';
import { useInstantSearch } from 'react-instantsearch-hooks-web';
import searchInsights from 'search-insights';

import { UserInfoCtx } from '../../containers/CommonLayout/CommonLayout';
import { generateRandomString } from '../helpers';

export const ALGOLIA_USER_TOKEN_NAME = 'algoliaToken';

const useInsightsMiddleware = ({
  canCheckToken,
  allowedInsightMethods,
  queryID,
}: {
  canCheckToken?: boolean;
  allowedInsightMethods: string[];
  queryID?: string;
}) => {
  const { use } = useInstantSearch();
  const allowedInsightMethodsRef = useRef(allowedInsightMethods);
  const { userInfo } = useContext(UserInfoCtx);
  const userId = userInfo?.id;

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: searchInsights,
      onEvent: (event, searchInsights) => {
        const { insightsMethod, payload, eventType } = event;

        if (
          searchInsights &&
          insightsMethod &&
          eventType === 'click' &&
          allowedInsightMethodsRef.current.includes(insightsMethod)
        ) {
          searchInsights(insightsMethod, { ...payload, queryID });
        }
      },
    });

    if (canCheckToken) {
      let token;
      if (!userId) {
        token = localStorage.getItem(ALGOLIA_USER_TOKEN_NAME);
        if (!token) {
          token = generateRandomString(20);
          localStorage.setItem(ALGOLIA_USER_TOKEN_NAME, token);
        }
      } else {
        token = md5(userId);
      }

      searchInsights('setUserToken', token);

      use(middleware);
    }

    return use(middleware);
  }, [use, userId, canCheckToken, allowedInsightMethodsRef, queryID]);

  return null;
};

export default useInsightsMiddleware;
